<template>
  <div class="class-big-screen">
    <div class="top-select-container">
      <div class="org-container">
        <p class="org-container-name">{{ schoolSelectName || '- -' }}</p>
        <img
          class="org-container-icon"
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png"
          alt="切换"
          @click="switchingSchoolDialogFlag = true"
        />
      </div>
      <div class="org-container" style="position: relative">
        <p class="org-container-name">教室编号</p>
        <a-select
          v-model="panoramaClassroomCode"
          style="width: 200px"
          @change="handleClassroomChange"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option :value="classroomCode" v-for="(classroomCode, index) in panoramaClassroomList" :key="index">
            {{ classroomCode }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div class="data-screen-box">
      <div class="screen-item" v-for="(screen, index) in allScreenDataList" :key="screen.screenNo">
        <div class="screen-title">{{ screen.screenNo }}号大屏</div>
        <div class="filter-line">
          <div class="left-select" style="position: relative">
            <a-select
              :default-value="filterType"
              style="width: 240px; height: 32px; margin-right: 12px"
              showArrow
              @change="handleFilterType"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-icon slot="suffixIcon" type="caret-down" />
              <a-select-option :value="1">按楼栋展示视频</a-select-option>
            </a-select>
            <!-- 楼栋筛选 -->
            <a-select
              mode="multiple"
              :value="selectObj['currentSelectBuild_' + screen.screenNo]"
              style="width: 240px; height: 32px"
              dropdownClassName="dropdown-item"
              placeholder="请选择楼栋，可多选"
              option-label-prop="label"
              showArrow
              :maxTagCount="1"
              @change="handleMultipleChange($event, screen, index)"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-icon slot="suffixIcon" type="caret-down" />
              <a-select-option
                v-for="(build, index) in buildFilterOptions"
                :key="index"
                :value="build.id"
                :label="build.buildingName"
              >
                <div class="option-box">
                  <a-checkbox
                    v-if="
                      selectObj['currentSelectBuild_' + screen.screenNo] &&
                      selectObj['currentSelectBuild_' + screen.screenNo].indexOf(build.id) > -1
                    "
                    :checked="true"
                  ></a-checkbox>
                  <a-checkbox v-else :checked="false"></a-checkbox>
                  <span class="filter-item">{{ build.buildingName }}</span>
                </div>
              </a-select-option>
            </a-select>
          </div>

          <div class="change-data-btn" @click="nextBatch(screen, index)">换一批</div>
        </div>
        <div class="class-list">
          <!-- 一期可以选择重复的课，liveId可能会重复，故用index遍历 -->
          <ClassItem
            v-for="(item, index) in screen.liveList"
            :key="index"
            :classItem="item"
            :currentIndex="index"
            :screenFilter="{
              screenNo: screen.screenNo,
              filterOptions: selectObj['currentSelectBuild_' + screen.screenNo],
              buildFilterOptions: buildFilterOptions
            }"
            :panoramaClassroomCode="panoramaClassroomCode"
          />
        </div>
      </div>
    </div>

    <SwitchSchool
      :switchingSchoolDialogFlag="switchingSchoolDialogFlag"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
  </div>
</template>

<script>
import ClassItem from './components/classItem.vue'
import SwitchSchool from '@/components/switchingSchool'
import { mapMutations, mapGetters, mapActions } from 'vuex'
const SOCKET_MSG_TYPE = {
  END_CLASS: '4004', // 下课指令
  PAD_CHECK: 'padChange', // ipad重新勾选指令
  DATA_SCREEN_CHANGE: 'data_screen_change', // 大屏数据变化指令
  CHANGE_LIVE: 'change_live' // 监测到课没有流时的替换指令
}
export default {
  name: 'DataScreen',
  components: {
    ClassItem,
    SwitchSchool
  },
  data() {
    return {
      // zrtc 相关
      listenedOnSignalMessage: false,
      clientOfZRTC: null,
      socketMsg: {},
      // 屏幕数据相关
      allScreenDataList: [],
      // 筛选条件相关
      filterType: '1',
      buildFilterOptions: [],
      selectObj: {
        currentSelectBuild_1: [],
        currentSelectBuild_2: [],
        currentSelectBuild_4: [],
        currentSelectBuild_5: []
      },
      selectBuilding: {
        selectBuilding_1: [],
        selectBuilding_2: [],
        selectBuilding_4: [],
        selectBuilding_5: []
      },
      switchingSchoolDialogFlag: false,
      schoolCode: '',
      panoramaClassroomCode: '',
      panoramaClassroomList: []
    }
  },
  computed: {
    ...mapGetters('bigScreenZrtc', ['getClientOfZRTC', 'getSocketMsg', 'getListenedOnSignalMessage']),
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
  },
  watch: {
    getSocketMsg: {
      handler: function (newVal) {
        this.dealSocketMsg(newVal)
      }
    },
    schoolSelect: {
      handler: async function (newVal) {
        if (!newVal) return
        this.schoolCode = newVal
        await this.getPanoramaClassroomList()
        await this.getConnectSocket()
        await this.getInitEachScreenData()
      },
      immediate: true
    }
  },
  created() {
    // this.getInitEachScreenData()
    // this.getConnectSocket()
  },
  methods: {
    ...mapActions('bigScreenZrtc', {
      ZRTCInit: 'ZRTCInit',
      getSocketMessage: 'getSocketMessage'
    }),
    handleSwitchingSchoolDialogClose() {
      this.switchingSchoolDialogFlag = false
    },
    // 切换全景教室
    handleClassroomChange(value) {
      this.panoramaClassroomCode = value
      this.getConnectSocket()
      this.getInitEachScreenData()
    },
    // 获取全景教室数据列表
    async getPanoramaClassroomList() {
      const res = await this.$http.getPanoramaClassroomCodeList({
        schoolCode: String(this.schoolCode)
      })
      if (res.code === 200 && res.rt && res.rt.length) {
        this.panoramaClassroomList = res.rt || []
        this.panoramaClassroomCode = this.panoramaClassroomList[0]
      } else {
        this.panoramaClassroomList = []
        this.panoramaClassroomCode = ''
      }
      console.log('getPanoramaClassroomCodeList🐶:>>>>>>>', res, 'src/views/DataScreen/index.vue')
    },
    async getConnectSocket() {
      await this.ZRTCInit({ schoolCode: this.schoolCode })
    },
    async getInitEachScreenData() {
      const { rt } = await this.$http.getFilterOptions({
        schoolCode: this.schoolCode
      })
      console.log('楼栋列表', rt)
      this.filterType = rt[0]?.filterType
      this.buildFilterOptions = rt[0]?.filterOptions

      this.allScreenDataList = []
      const { code, rt: list } = await this.$http.initEachScreenData({
        panoramaClassroomCode: this.panoramaClassroomCode || undefined
      })
      console.log('初始化大屏直播列表', code, list)

      let screenSort = Object.keys(list)
      screenSort.forEach((item, index) => {
        const everyScreenData = list[item]
        // 按位置从小到大排序
        // everyScreenData.liveList?.sort((a, b) => a.screenSort - b.screenSort)

        let screenListItem = {
          screenNo: item,
          ...everyScreenData
        }
        // 在楼栋管理中删除教学楼，但是上一次选中了这个教学楼，需要过滤一下
        if (
          everyScreenData.lastSelectBuilding &&
          everyScreenData.lastSelectBuilding.length &&
          everyScreenData.lastSelectBuilding[0]
        ) {
          everyScreenData.lastSelectBuilding = everyScreenData.lastSelectBuilding.filter((item) => item.length)
          let buildingIdsArr = []
          this.buildFilterOptions.map((item) => {
            buildingIdsArr.push(item.id)
          })
          console.log('buildingIdsArr🐶:>>>>>>>', buildingIdsArr, 'src/views/DataScreen/index.vue')
          everyScreenData.lastSelectBuilding.forEach((item) => {
            if (buildingIdsArr.indexOf(Number(item)) >= 0) {
              this.selectBuilding['selectBuilding_' + screenListItem.screenNo].push(Number(item))
            }
          })
        }

        this.allScreenDataList.push(screenListItem)
        // 判断everyScreenData.lastSelectBuilding[0]存在 是因为用户清除所有选项后 刷新页面接口的lastSelectBuilding会返回['']
        this.selectObj['currentSelectBuild_' + screenListItem.screenNo] =
          everyScreenData.lastSelectBuilding &&
          everyScreenData.lastSelectBuilding.length &&
          everyScreenData.lastSelectBuilding[0]
            ? this.selectBuilding['selectBuilding_' + screenListItem.screenNo]
            : [this.buildFilterOptions[0]?.id]
      })
      console.log('screenListItem', this.allScreenDataList)
    },
    async getFilterOptions() {
      const { rt } = await this.$http.getFilterOptions()
      this.filterType = rt[0]?.filterType
      this.buildFilterOptions = rt[0]?.filterOptions
      console.log('buildFilterOptions:>>>>>', this.buildFilterOptions)
    },
    handleFilterType() {},
    handleMultipleChange(event, screen, index) {
      console.log('handleChange', event, screen, index)
      this.selectObj['currentSelectBuild_' + screen.screenNo] = event
      localStorage.setItem('selectBuildingObj', JSON.stringify(this.selectObj))
      // 切换楼栋后需要刷新列表
      this.handleChangeBuilding(event, screen, index)
    },
    async handleChangeBuilding(filterList, screen, index) {
      const res = await this.$http.changeBuilding({
        screenNo: screen.screenNo,
        filterType: 1,
        filterOptions: filterList.join(','),
        panoramaClassroomCode: this.panoramaClassroomCode || undefined,
        schoolCode: this.schoolCode
      })
      console.log('切换楼栋后刷新列表', this.allScreenDataList)
    },
    async nextBatch(screen, index) {
      let filterList = this.selectObj['currentSelectBuild_' + screen.screenNo]
      if (!filterList || !filterList.length) return this.$message.error('请选择至少一个楼栋')
      let currentScreenItem = JSON.parse(JSON.stringify(this.allScreenDataList[index]))

      const haveTimeItem = currentScreenItem.liveList?.filter((item) => item.liveId)

      // 获取当前大屏 最后一个直播的开始时间（倒序排列，即开始时间时间戳最小的）不满9条则不用传maxStartTime
      // let maxStartTime
      let minStartTime
      if (haveTimeItem && haveTimeItem.length) {
        // maxStartTime = Math.max.apply(Math, currentScreenItem.liveList?.map((item) => item.startTime))
        minStartTime = currentScreenItem.liveList?.sort((a, b) => a.startTime - b.startTime)[0]?.startTime
      }
      console.log('minStartTime---', minStartTime)
      const { rt: list } = await this.$http.getNextBatchClass({
        filterType: 1,
        filterOptions: filterList.join(','),
        screenNo: screen.screenNo || '',
        maxStartTime: minStartTime ? minStartTime : undefined, // 需要传最小开始时间，但接口参数名没改
        panoramaClassroomCode: this.panoramaClassroomCode || undefined,
        schoolCode: this.schoolCode
      })
      // this.allScreenDataList[index].liveList = list
    },
    async dealSocketMsg(message) {
      const { type, content } = message
      switch (type) {
        case SOCKET_MSG_TYPE.END_CLASS: // 下课指令
        case SOCKET_MSG_TYPE.CHANGE_LIVE: // 监测到课没有流时的替换指令
          // console.log('开始处理下课指令逻辑-----', type, content);
          // const { rt: classInfoList } = await this.$http.getEndclassInfo({
          //     liveId: content.liveId
          // })
          // console.log('下课指令-下课屏幕信息', classInfoList);

          // classInfoList.length && classInfoList.forEach(async info => {
          //     if (info.resultStatus == 1) {
          //         let currentList = this.allScreenDataList.find(item => item.screenNo == info.screenNo)
          //         console.log('currentList', currentList);
          //         // 获取当前大屏 最后一个直播的开始时间（倒序排列，即开始时间时间戳最小的）不满9条传最后一个，1条也没有则不传
          //         const filterList = currentList.liveList?.filter(item => item.liveId)
          //         // const maxStartTime = Math.max.apply(Math, filterList?.map((item) => item.startTime))
          //         const minStartTime = filterList?.sort((a, b) => a.startTime - b.startTime)[0]?.startTime
          //         console.log('minStartTime>>>>>>>>>>>', minStartTime);
          //         // 当前屏幕的筛选项
          //         let endFilter = this.selectObj['currentSelectBuild_' + info.screenNo]
          //         // 课程下课后获取一个课
          //         const { code, rt: newClass } = await this.$http.getOneNewClass({
          //             // maxStartTime: 1680855566000,
          //             maxStartTime: minStartTime ? minStartTime : undefined,
          //             filterType: 1,
          //             filterOptions: endFilter.join(',')
          //         })
          //         console.log('newCalss', newClass);
          //         if (code == 200) {
          //             let newLive = {
          //                 ...newClass,
          //                 screenSort: info.screenSort,
          //                 screenId: info.screenId,
          //                 largeScreenChecked: false
          //             }
          //             await this.setReselectLive(info.screenId, newLive, info)
          //         }
          //     }
          // })
          break
        case SOCKET_MSG_TYPE.PAD_CHECK: // ipad重新勾选指令
          const { screenNo, screenSort } = content
          this.allScreenDataList.map((item) => {
            item.liveList.map((live) => (live.largeScreenChecked = false))
            if (item.screenNo == screenNo) {
              item.liveList[screenSort - 1].largeScreenChecked = true
            }
          })
          break
        case SOCKET_MSG_TYPE.DATA_SCREEN_CHANGE: // 大屏数据变化指令
          console.log('大屏数据变化指令---------', content)
          this.handleScreenDataChange(content)
          break
      }
    },
    async setReselectLive(screenId, live, info) {
      // 没有LiveId也要调一下重选接口，大屏展示那边需要重选接口来监听数据变化
      // if (!live.liveId) return
      const res = await this.$http.reselectLive({
        screenId: screenId,
        liveId: live.liveId ? live.liveId : undefined,
        panoramaClassroomCode: this.panoramaClassroomCode || undefined
      })
      console.log('确认重选', res)
      if (res.code == 200) {
        // this.$message.success('操作成功')
        // 注意 info和screen数据不一样，但此方法需要的是info里面的screenNo数据
        this.allScreenDataList.map((item) => {
          if (item.screenNo == info.screenNo) {
            item.liveList.splice(info.screenSort - 1, 1, live)
          }
        })
      }
    },
    handleReselectList(item, screenNo, index) {
      this.allScreenDataList.map((screen) => {
        if (screen.screenNo == screenNo) {
          screen.liveList.splice(index, 1, item)
        }
      })
      console.log('重选后的大屏数据', this.allScreenDataList)
    },
    handleScreenDataChange(content) {
      localStorage.setItem('changeScreen', JSON.stringify(content))
      let screenNoArray = Object.keys(content)
      const screenList = screenNoArray.filter((item) => item != 3)
      console.log('screenList:(*^▽^*) >>>>>>>', screenList)

      // 按位置从小到大排序
      // content[curretScreenNo].liveList?.sort((a, b) => a.screenSort - b.screenSort)
      screenList.forEach((screen, index) => {
        this.allScreenDataList.map((item) => {
          if (item.screenNo == screen) {
            // 23.10.10 大屏数据更新时当前选中楼栋不会变，故去掉此逻辑
            // const lastSelectBuilding = content[screen].buildingName?.filter((item) => item !== '')
            // this.selectObj['currentSelectBuild_' + screen] = lastSelectBuilding

            // 解决 点击换一批后，选中框会闪现一下再停到正确课程卡片上
            item.liveList.map((live) => (live.largeScreenChecked = false))
            item.liveList = content[screen].liveList
          }
        })
      })
      console.log('收到变化指令后返回新的列表', this.allScreenDataList)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-select-container {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}
.org-container {
  display: flex;
  align-items: center;
  margin-right: 30px;
  .org-container-name {
    font-size: 14px;
    color: #1e2228;
    margin-right: 8px;
  }
  .org-container-icon {
    width: 16px;
    height: 16px;
    display: block;
    cursor: pointer;
    user-select: none;
  }
}
.data-screen-box {
  min-width: 1280px;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  // grid-template-rows: repeat(2, 350px);
  grid-template-rows: repeat(2, minmax(350px, 1fr));
  grid-gap: 16px;

  .screen-item {
    padding: 16px 16px 12px;
    background: #fff;
  }

  .dropdown-item {
    display: block;
  }
}
.screen-item {
  .screen-title {
    height: 14px;
    padding-left: 6px;
    font-size: 14px;
    text-align: left;
    color: #1e2228;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      width: 2px;
      height: 12px;
      background: #5f60d3;
    }
  }
  .filter-line {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .left-select {
      display: flex;
      align-items: center;
    }
    .change-data-btn {
      width: 60px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      text-align: center;
      color: #fff;
      background: #5f60d3;
      cursor: pointer;
    }
    ::v-deep {
      .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
        max-width: 110px;
      }
    }
  }
}
.class-list {
  margin-top: 8px;
  height: calc(100% - 50px);
  display: grid;
  grid-template-columns: repeat(3, minmax(185px, 33%));
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 8px;
  padding-bottom: 8px;
}
</style>
